<div
  class="p-d-flex p-flex-column p-mt-3"
  *ngIf="avansneUplateTable?.length > 0"
>
  <p-table
    [value]="avansneUplateTable.controls"
    styleClass="p-datatable-striped p-datatable-gridlines"
    dataKey="id"
    editMode="row"
    responsiveLayout="scroll"
  >
    <!-- START HEADER -->
    <ng-template pTemplate="header">
      <!-- header columns -->
      <tr class="columns">
        <th style="width: 7vw">Avansni račun</th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayS20">
          S20
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayPdv20">
          PDV 20%
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayS10">
          S10
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayPdv10">
          PDV 10%
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayS8">
          S8
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayPdv8">
          PDV 8%
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayAE">
          AE
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayAE10">
          AE10
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayAE20">
          AE20
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayO">
          O
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayE">
          E
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayR">
          R
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayZ">
          Z
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplaySS">
          SS
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayOE">
          OE
        </th>
        <th style="width: 7vw" class="p-text-right" *ngIf="shouldDisplayN">
          N
        </th>
        <th style="width: 7vw" *ngIf="shouldDisplayActions"></th>
      </tr>
    </ng-template>
    <!-- START BODY -->
    <ng-template
      pTemplate="body"
      let-uplata
      let-rowIndex="rowIndex"
      let-editing="editing"
    >
      <ng-container>
        <tr [pEditableRow]="uplata">
          <!-- Broj avansnog racuna -->
          <td class="p-text-center">
            <button
              pButton
              type="button"
              [label]="uplata.get('avansniRacunBroj').value"
              class="p-text-left p-button-link p-p-0 text-underline"
              (click)="goToAvansniRacun(rowIndex)"
            ></button>
          </td>
          <!-- S20 -->
          <td class="p-text-right" *ngIf="shouldDisplayS20">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovica20').value !== null && uplata.get('evidentiranaOsnovica20').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                  <kodit-number-input
                    [formCtrl]="uplata.get('evidentiranaOsnovica20')"
                    formCtrlId="s20"
                  ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovica20').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- PDV 20% -->
          <td class="p-text-right" *ngIf="shouldDisplayPdv20">
            {{ uplata.get('evidentiranPdv20').value | decimalNumber }}
          </td>
          <!-- S10 -->
          <td class="p-text-right" *ngIf="shouldDisplayS10">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovica10').value !== null && uplata.get('evidentiranaOsnovica10').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                  <kodit-number-input
                    [formCtrl]="uplata.get('evidentiranaOsnovica10')"
                    formCtrlId="s10"
                  ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovica10').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- PDV 10% -->
          <td class="p-text-right" *ngIf="shouldDisplayPdv10">
            {{ uplata.get('evidentiranPdv10').value | decimalNumber }}
          </td>
          <!-- S8 -->
          <td class="p-text-right" *ngIf="shouldDisplayS8">
               <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovica8').value !== null && uplata.get('evidentiranaOsnovica8').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                  <kodit-number-input
                    [formCtrl]="uplata.get('evidentiranaOsnovica8')"
                    formCtrlId="s8"
                  ></kodit-number-input>
                </kodit-field>
               </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovica8').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- PDV 8% -->
          <td class="p-text-right" *ngIf="shouldDisplayPdv8">
            {{ uplata.get('evidentiranPdv8').value | decimalNumber }}
          </td>
          <!-- AE -->
          <td class="p-text-right" *ngIf="shouldDisplayAE">
               <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaAE').value !== null && uplata.get('evidentiranaOsnovicaAE').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaAE')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaAE').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- AE10 -->
          <td class="p-text-right" *ngIf="shouldDisplayAE10">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaAE10').value !== null && uplata.get('evidentiranaOsnovicaAE10').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaAE10')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaAE10').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- AE20 -->
          <td class="p-text-right" *ngIf="shouldDisplayAE20">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaAE20').value !== null && uplata.get('evidentiranaOsnovicaAE20').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaAE20')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaAE20').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- O -->
          <td class="p-text-right" *ngIf="shouldDisplayO">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaO').value !== null && uplata.get('evidentiranaOsnovicaO').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaO')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaO').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- E -->
          <td class="p-text-right" *ngIf="shouldDisplayE">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaE').value !== null && uplata.get('evidentiranaOsnovicaE').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaE')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaE').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- R -->
          <td class="p-text-right" *ngIf="shouldDisplayR">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaR').value !== null && uplata.get('evidentiranaOsnovicaR').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaR')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaR').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- Z -->
          <td class="p-text-right" *ngIf="shouldDisplayZ">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaZ').value !== null && uplata.get('evidentiranaOsnovicaZ').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaZ')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaZ').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- SS -->
          <td class="p-text-right" *ngIf="shouldDisplaySS">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaSS').value !== null && uplata.get('evidentiranaOsnovicaSS').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaSS')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaSS').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- OE -->
          <td class="p-text-right" *ngIf="shouldDisplayOE">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaOE').value !== null && uplata.get('evidentiranaOsnovicaOE').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaOE')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaOE').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- N -->
          <td class="p-text-right" *ngIf="shouldDisplayN">
              <ng-container *ngIf="globalEditMode && (uplata.get('evidentiranaOsnovicaN').value !== null && uplata.get('evidentiranaOsnovicaN').value !== undefined); else prikaz">
                <kodit-field class="p-fluid">
                <kodit-number-input
                  [formCtrl]="uplata.get('evidentiranaOsnovicaN')"
                ></kodit-number-input>
                </kodit-field>
              </ng-container>
              <ng-template #prikaz>
                {{ uplata.get('evidentiranaOsnovicaN').value | decimalNumber }}
              </ng-template>
          </td>
          <!-- akcije -->
          <td style="text-align: center" *ngIf="shouldDisplayActions">
            <button
              *ngIf="!editing"
              pButton
              pRipple
              type="button"
              icon="fa-regular fa-trash-alt"
              (click)="onRowDelete(rowIndex)"
              class="p-button-rounded p-button-text p-button-danger"
            ></button>
          </td>
        </tr>
      </ng-container>
    </ng-template>
  </p-table>
</div>

<div *ngIf="shouldDisplayMsg && !(avansneUplateTable?.length > 0)" class="p-text-left">
  Na računu nema registrovanih avansnih uplata
</div>
